@if (isZitiWarning) {
  <div class="modal solid open" id="ZitiWarningModal">
    <div (click)="cancel()" class="miniClose cancel icon-HamburgerAppClose"></div>
    <div [ngClass]="{ noZiti: noZitiGateways }" class="title overrideFont">
      FYI, Ziti capable clients cannot interact with the following
      {{ typeString }}.{{ noZitiGateways ? ' ' + noZitiGatewayString : '' }}
    </div>
    <div class="icon" style="background-image: url(/assets/svgs/ZitiGateway.svg)"></div>
    <div [ngClass]="{ noZiti: noZitiGateways }" class="row">
      <div
            [ngClass]="{
                three: hasGatewaysAndServices,
                two: !hasGatewaysAndServices
            }"
        class="warningHeader"
        >
        <div>Clients</div>
        @if (services && services.length > 0) {
          <div>Services</div>
        }
        @if (gateways && gateways.length > 0) {
          <div>Gateways</div>
        }
      </div>
      <div
            [ngClass]="{
                three: hasGatewaysAndServices,
                two: !hasGatewaysAndServices
            }"
        class="warningRow"
        >
        <div>
          @for (item of this.clients; track item) {
            <div class="warning"></div>
          }
        </div>
        <div class="warningCol">
          @for (item of this.clients; track item) {
            <div>{{ item.name }}</div>
          }
        </div>
        @if (services && services.length > 0) {
          <div class="warningCol">
            @for (item of this.services; track item) {
              <div>
                {{
                item.name
                ? item.name
                : item.serviceClass === 'GW'
                ? item.gatewayIp + (item.gatewayCidrBlock ? '/' + item.gatewayCidrBlock : '')
                : item.networkIp
                }}
              </div>
            }
          </div>
        }
        @if (gateways && gateways.length > 0) {
          <div class="warningCol">
            @for (item of this.gateways; track item) {
              <div>
                {{ item.name }}
              </div>
            }
          </div>
        }
      </div>
    </div>
    <div class="buttons">
      <div (click)="cancel()" class="linkButton cancel" id="CancelZitiWarningButton">
        {{ cancelAction }}
      </div>
      <button (click)="close()" class="save" id="CloseWarningButton">OK, Thanks for the heads up, Proceed</button>
    </div>
  </div>
}

@if (!isZitiWarning) {
  <div class="modal solid open" id="WarningListModal">
    <div (click)="cancel()" class="miniClose cancel icon-HamburgerAppClose"></div>
    <div [ngClass]="{ overrideFont: overrideFont }" class="title">
      {{ title }}
    </div>
    <div class="icon {{ icon }}"></div>
    <div class="row generic">
      <div [ngClass]="{ four: list2.length > 0, two: list2.length === 0 }" class="warningHeader">
        <div>{{ list1Title }}</div>
        @if (list2.length > 0) {
          <div>{{ list2Title }}</div>
        }
      </div>
      <div [ngClass]="{ four: list2.length > 0, two: list2.length === 0 }" class="warningRow">
        <div>
          @for (item of list1; track item) {
            <div class="warning"></div>
          }
        </div>
        <div class="warningCol">
          @for (item of list1; track item) {
            <div>{{ item.name }}</div>
          }
        </div>
        <div>
          @for (item of list2; track item) {
            <div class="success"></div>
          }
        </div>
        <div class="successCol">
          @for (item of list2; track item) {
            <div>{{ item.name }}</div>
          }
        </div>
      </div>
    </div>
    <div class="buttons">
      <button (click)="close()" class="save" id="CloseWarningButton">OK, Thanks for the heads up, Proceed</button>
    </div>
  </div>
}
